import React from "react";
import { CategoryView } from "@/types/report";
import { Box } from "@mui/material";
import Incomings from "./incomings";
import Outgoings from "./outgoings";
import ActionBar from "./action-bar";
import { FormProvider, useForm } from "react-hook-form";
import { Forms } from "@/types/form";
import { useCategorySubmit, useCategoryFilter, useDownloadCategoryAttachment } from "./hooks";
import useFormListeners from "@/hooks/useFormListeners";

interface Props {
    data: {
        incomings: CategoryView[];
        outgoings: CategoryView[];
    };
}

export type ViewType = "all" | "income" | "expense";
export type FormField = CategoryView & { fieldId: string;  originalIndex: number };

const CategoriesOverview: React.FC<Props> = ({ data }) => {
    const methods = useForm<Forms["Category"]>({
        defaultValues: { incomings: data.incomings, outgoings: data.outgoings },
    });

    const {
        control,
        handleSubmit,
        formState: { isDirty, isSubmitting },
    } = methods;
    useFormListeners("category-form", isDirty, isSubmitting);
    const onSubmit = useCategorySubmit(methods);
    const { onDownload, isLoading } = useDownloadCategoryAttachment();

    const {
        viewType,
        setViewType,
        selectedCategoryDescriptions,
        setSelectedCategoryDescriptions,
        filteredIncomings,
        filteredOutgoings,
        allCategoryDescriptions,
    } = useCategoryFilter(control);
    return (
        <FormProvider {...methods}>
            <form id="category-form" onSubmit={handleSubmit(onSubmit)}>
                <Box marginTop={0} padding={0}>
                    <ActionBar
                        viewType={viewType}
                        onViewTypeChange={setViewType}
                        selectedCategoryDescriptions={selectedCategoryDescriptions}
                        onCategoryDescriptionChange={setSelectedCategoryDescriptions}
                        allCategoryDescriptions={allCategoryDescriptions}
                    />

                    {(viewType === "all" || viewType === "income") && (
                        <Incomings
                            filteredData={filteredIncomings}
                            onDownload={onDownload}
                            isLoading={isLoading}
                        />
                    )}
                    {(viewType === "all" || viewType === "expense") && (
                        <Outgoings
                            filteredData={filteredOutgoings}
                            onDownload={onDownload}
                            isLoading={isLoading}
                        />
                    )}
                </Box>
            </form>
        </FormProvider>
    );
};

export default CategoriesOverview;
